import React, { useState } from "react";
import "./FAQSection.css";

const faqData = [
  {
    question: "Where Are Your Offices?",
    answer:
      "RelyOnne UK operates from the United Kingdom. Please contact us for our registered office and warehouse details.",
  },
  {
    question: "Where Can I Find Your Latest Offers?",
    answer:
      "You can contact our sales team for the latest deals and product offers.",
  },
  {
    question: "How Do You Deliver?",
    answer:
      "We work with reliable logistics partners to ensure safe and timely delivery across the UK.",
  },
  {
    question: "Can You Supply Large Bulk Orders?",
    answer:
      "Yes. We specialize in supplying both small and large bulk paper orders for businesses.",
  },
  {
    question: "Are Your Products Sustainably Sourced?",
    answer:
      "Yes. We aim to source products from responsible and sustainable manufacturers whenever possible.",
  },
  {
    question: "How Long Will It Take For My Order To Arrive?",
    answer:
      "Delivery times depend on stock availability and your location. Our team will provide an estimated delivery date when your order is confirmed.",
  },
  {
    question: "Do You Offer Storage?",
    answer:
      "Please contact our sales team to discuss storage and scheduled delivery options.",
  },
  {
    question: "What Is The Minimum Order Quantity?",
    answer:
      "Minimum order quantities vary depending on the product. Contact us for details.",
  },
  {
    question: "What If I Have An Issue With My Order?",
    answer:
      "Our customer support team will work quickly to resolve any issues related to your order.",
  },
  {
    question: "Can You Source Specific Paper Products?",
    answer:
      "Yes. If you cannot find a product you're looking for, let us know and we'll do our best to source it.",
  },
];

function FAQItem({ item }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="faq-item">
      <button
        className="faq-question"
        onClick={() => setOpen(!open)}
      >
        <span>{item.question}</span>
        <span className="icon">{open ? "−" : "+"}</span>
      </button>

      {open && <div className="faq-answer">{item.answer}</div>}
    </div>
  );
}

export default function FAQSection() {
  const left = faqData.slice(0, 5);
  const right = faqData.slice(5);

  return (
    <section className="faq-section">
      <h2>FAQ</h2>

      <p className="faq-contact">
        If you have questions that aren't listed here, please contact our sales
        team:
        <strong> +44 7515866571 </strong>
        or
        <a href="mailto:contact@relyonneuk.com">
          {" "}contact@relyonneuk.com
        </a>
      </p>

      <div className="faq-grid">
        <div>
          {left.map((item, index) => (
            <FAQItem key={index} item={item} />
          ))}
        </div>

        <div>
          {right.map((item, index) => (
            <FAQItem key={index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
